import React from 'react';
import { isMobile } from 'react-device-detect';
import { formatStatsValue } from 'common-helpers/utils';
import Row, { RowBetween } from 'components/Row';
import { AutoColumn } from 'components/Column';
import { TYPE } from 'theme';
import { Card } from '../styled';
import { UserGecStatsV2 } from 'gql-ops/graph/__generated__/request';
import { CardContent, Season1Empty, WarningIcon } from './seasonStyles';

interface Season1Props {
    gecStatsV2: UserGecStatsV2;
}

const Season1: React.FC<Season1Props> = ({ gecStatsV2 }) => {
    return (
        <>
            <Row>
                <TYPE.main fontSize={16} fontWeight={700} mobileFz={14}>
                    Season 1 (Ended)
                </TYPE.main>
            </Row>
            {Number(gecStatsV2.season1Stats?.totalGEC) > 0 && Number(gecStatsV2.season1Stats?.totalPoint) > 0 ? (
                <RowBetween gap="20px" wrap="wrap">
                    <Card
                        background="#121212"
                        bgIcon="rocket"
                        height="169px"
                        width={isMobile ? '100%' : '600px'}
                        padding="20px"
                    >
                        <CardContent>
                            <AutoColumn gap="6px">
                                <TYPE.desc fontSize={14} fontWeight={500}>
                                    Season 1 Points
                                </TYPE.desc>
                                <TYPE.desc fontSize={10} color="#999">
                                    Season 1 points earned from activities
                                </TYPE.desc>
                            </AutoColumn>
                            <Row gap="6px" align="center" alignItems="center" marginTop="30px">
                                <TYPE.main fontSize={24} fontWeight={500}>
                                    {formatStatsValue(BigInt(gecStatsV2.season1Stats?.totalPoint || '0').toString())}
                                </TYPE.main>
                                <TYPE.desc fontSize={14}>Points</TYPE.desc>
                            </Row>
                        </CardContent>
                    </Card>
                </RowBetween>
            ) : (
                <Season1Empty>
                    <WarningIcon />
                    <TYPE.desc fontSize={12} color="#999" style={{ width: 'fit-content', wordBreak: 'break-word' }}>
                        Opps: You missed the season 1 activities. Please take part in season 3 community campaign and
                        share future rewards.
                    </TYPE.desc>
                </Season1Empty>
            )}
        </>
    );
};

export default Season1;
